import { render } from "./InputWithLabel.vue?vue&type=template&id=60a7b35e&scoped=true"
import script from "./InputWithLabel.vue?vue&type=script&lang=js"
export * from "./InputWithLabel.vue?vue&type=script&lang=js"

import "./InputWithLabel.vue?vue&type=style&index=0&id=60a7b35e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a7b35e"]])

export default __exports__